export const name = "LENGTH";
export const summary = `Gets the length of a \`STRING\` or \`BYTES\` value.`;
export const reference = `
## LENGTH

Gets the length of a \`STRING\` or \`BYTES\` value.

\`\`\`
LENGTH(value)
\`\`\`

### Description

Returns the length of the \`STRING\` or \`BYTES\` value. The returned value is in characters for \`STRING\` arguments and in bytes for the \`BYTES\`argument.


### Return type

\`INT64\`


### Examples



\`\`\`
SELECT
  LENGTH('абвгд') AS string_example,
  LENGTH(CAST('абвгд' AS BYTES)) AS bytes_example;

/*----------------+---------------*
 | string_example | bytes_example |
 +----------------+---------------+
 | 5 | 10 |
 *----------------+---------------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
